import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Text } from 'Components/Text/Text';
import { ICON_ALERT_WARNING } from 'Config/Icons';

import styles from './RequiresAttentionMarker.module.css';

interface RequiresAttentionMarkerProps {
    children: string;
    size: 'sm' | 'lg';
    type: 'negative' | 'warning';
}

/**
 * Visually marks something as needing the user's attention. Uses colored text and a colored icon. There are two variants:
 * * negative - red text that draws the user's attention towards something urgent or something that has failed.
 * * warning - orange text that draws the user's attention towards something that needs to be addressed non-urgently.
 */
export const RequiresAttentionMarker = (props: RequiresAttentionMarkerProps) => {
    const colorClass = (() => {
        switch (props.type) {
            case 'negative':
                return styles.red;
            case 'warning':
                return styles.orange;
        }
    })();

    const iconSize = (() => {
        switch (props.size) {
            case 'sm':
                return 'xs';
            case 'lg':
                return '2xl';
        }
    })();

    return (
        <div className={styles.markerRow}>
            <FontAwesomeIcon icon={ICON_ALERT_WARNING} className={colorClass} size={iconSize} />
            <Text noStyles>
                <span className={colorClass}>{props.children}</span>
            </Text>
        </div>
    );
};
